// Production warehouse catalogue, matching the existing backend listAlmacenes.
const warehouseNames = {
  '1': 'Betxí',
  '2': 'Alquerías',
  '3': 'Ulldecona',
}

export const getWarehouseLabel = (code, name) => (
  (name && String(name).trim() !== String(code) ? String(name).trim() : '')
  || warehouseNames[String(code)]
  || `Almacen ${code}`
)
